import { ProfileOption, usePreferences } from '../../../hooks/use-preferences';
import { GlobalTabsKeysEnum } from '../../../providers/models/custom-app-links';
import { useThemeMode } from '../../../providers/theme-provider';
import { ThemeMode } from '../../../theme/theme-store';
import SettingGroup from './setting-group';

import './styles.scss';

const MySettings = () => {
  const { preferences, setPreference, profileOptions, homepageOptions } = usePreferences();
  const { resolvedMode, setMode } = useThemeMode();

  return (
    <div className="my-settings-container">
      <SettingGroup
        title="Style settings"
        options={[
          {
            title: 'Appearance',
            subtitle: 'Customize how our web app looks on your device.',
            options: [
              {
                name: 'Light',
                value: 'light',
              },
              {
                name: 'Dark',
                value: 'dark',
              },
            ],
            value: resolvedMode,
            setValue: (val) => setMode(val as ThemeMode),
            className: 'theme-select',
          },
          {
            title: 'Profile',
            subtitle: 'Choose how your profile will be displayed in the menu.',
            options: profileOptions,
            value: preferences.profile,
            setValue: (val) => setPreference('profile', val as ProfileOption),
          },
        ]}
      />
      <SettingGroup
        title="Other settings"
        options={[
          {
            title: 'Default Homepage',
            subtitle: "You'll see this page when you log in or select our logo",
            options: homepageOptions,
            value: preferences.homepage,
            setValue: (val) => setPreference('homepage', val as GlobalTabsKeysEnum),
          },
        ]}
      />
    </div>
  );
};

export default MySettings;
